// Module
var code = `<div appHeaderBar>
    <header-bar-title>Pay Assessments - Confirm Property</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true"
                  [pmcId]="property.hoa.pmc.couponId" [hoaId]="property.hoa.couponId" [propertyId]="property.couponId">
    <form name="RegistrationForm" id="RegistrationForm" #registrationForm="ngForm">
        <div class="HOA-container HOA-container__content--borderNone">
            <p class="HOA-flextable-component__subheader u-pL3">Property Pay is now part of First Citizens Bank</p>
        </div>
        <div class="HOA-container">
            <div class="HOA-container__header">
                <h1 tid="oneTimePaymentLabel" id="oneTimePaymentLabel" class="HOA-container__header-text">
                    Pay {{paymentEntityType === paymentEntityTypes.AMENITY ? 'Amenities' : 'Assessments'}} - Confirm Property
                </h1>
                <button type="button" tid="registerLink" id="registerLink" class="Button Button--blue HOA-guest-signup-button" (click)="registerGuestNow()">
                    Sign Up
                </button>
            </div>
            <div class="HOA-container__content">
                <!--(MMDP-1970: email-address-exists="emailAddressExists" removed until Registered User functionality is enabled. )-->
                <app-personal-info [personalInfoData]="personalInfoData" (invalidCheck)="emailAddressValid(\$event)"></app-personal-info>
                <div class="HOA-container__content-hrule HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--100 u-mT5"></div>
                <div tid="propertyDetailsLabel" id="propertyDetailsLabel" class="HOA-flextable-component__subheader u-mT3 u-mB7">Property Details</div>

                <app-property-form-left [anonymous]="true"
                                        class="HOA-flextable-component__form-vertical HOA-flextable-component__cell--alt50 HOA-flextable-component__form"
                                        [property]="property" (blurFunction)="propertyFormLeftChange()" (invalidCheck)="invalidCheck(\$event.invalidObj)"></app-property-form-left>
                <app-address-form
                    [property]="property"
                    (invalidCheck)="invalidCheck(\$event.invalidObj)"
                    [showPropertyNickname]="false"
                    [setPropertyAddressEvent]="setPropertyAddressSubject.asObservable()"
                ></app-address-form>
                <!--<div class="HOA-guest-payment-padding-helper HOA-flextable-component__cell&#45;&#45;alt50 HOA-flextable-component__form&#45;&#45;right u-pB8 HOA-guest-payment-text-center-sm" ng-hide="false">  &lt;!&ndash; TODO: This needs to be wired up as a post email confirmation hook. &ndash;&gt;-->
                <!--<div class="HOA-guest-payment-header HOA-propertylanding-content__subheader-bold u-pB3">Benefits of Registering</div>-->
                <!--<div class="HOA-font-light">Register to quickly and easily access your payment history and schedule property payments. Registering is simple, takes only a few moments and will save you time on future payments.</div>-->
                <!--<a name="registerNow" id="registerNow" tid="registerNow" class="Button Button&#45;&#45;link " (click)="registerNow()">Register Now</a>-->
                <!--</div>-->
            </div>
            <div *ngIf="paymentEntityType !== paymentEntityTypes.AMENITY" class="HOA-flex-component HOA-flex-component__column-center">
                <div class="HOA-flex-component HOA-guest-payment-button-container">
                    <button *ngIf="allowPayByCheck" name="payByCheck" id="payByCheck" tid="payByCheck" type="button"
                            (click)="submit('check')" class="Button Button--blue " [disabled]="invalid() || invalidCheckVar || emailAddressError">
                        <span [ngClass]="{'u-visibility-hidden': isLoadingFindMyProperty}">Pay by eCheck</span>
                    </button>
                    <button *ngIf="allowPayByCard" name="payByCard" id="payByCard" tid="payByCard" type="button" (click)="submit('card')"
                            class="Button Button--blue " [disabled]="invalid() || invalidCheckVar || emailAddressError">
                        <span [ngClass]="{'u-visibility-hidden': isLoadingFindMyProperty}">Pay by Card</span>
                    </button>
                </div>
                <button name="cancel" id="cancel" tid="cancel" type="button" class="Button Button--link HOA-guest-payment-cancel-button" (click)="cancel()">
                    Cancel
                </button>
            </div>
            <div *ngIf="paymentEntityType === paymentEntityTypes.AMENITY" class="HOA-flex-component HOA-flex-component__column-center">
                <div class="HOA-flex-component HOA-guest-payment-button-container">
                    <button name="amenitiesCancel" id="amenitiesCancel" tid="amenitiesCancel" type="button" class="Button Button--link" (click)="cancel()">
                        Cancel
                    </button>
                    <button name="nextButton" id="nextButton" tid="nextButton" type="button" (click)="submit()"
                            class="Button Button--blue " [disabled]="invalid() || invalidCheckVar || emailAddressError">
                        <span [ngClass]="{'u-visibility-hidden': isLoadingFindMyProperty}">Next</span>
                    </button>
                </div>
            </div>
            <div class="u-pT2 HOA-font-fine-print"><span class="asterisk-required">&#42;</span>&nbsp;Indicates required field</div>
        </div>
    </form>
</app-page-content>
`;
// Exports
module.exports = code;